import { createContext, useContext } from "react";
import { QueryClient } from "@tanstack/react-query";
import type { ErrorHandlerService } from "@/shared/services/error-handler.service";
import { StorageService } from "@/shared/services/localStorage.service";
import type { NotificationService } from "@/shared/services/notification.service";
import { PushService } from "@/shared/services/push.service";

export type AppDependencies = {
  storageService: StorageService
  queryClient: QueryClient
  pushService: PushService
  notificationService: NotificationService
  errorHandlerService: ErrorHandlerService
};

export const DependenciesContext = createContext<AppDependencies | null>(null);

export const useDependencies = (): AppDependencies => {
  const dependencies = useContext(DependenciesContext);
  if (!dependencies) {
    throw new Error("useDependencies must be used within a DependenciesProvider");
  }
  return dependencies;
};
